import {$, w} from './constants';

export function calculatorAFAS() {
    // Guardar el valor inicial del input
    let initialValue = $('#quantity').val();

    // Función para actualizar los resultados
    function updateResults(quantity) {
        if (!isNaN(quantity) && quantity.length > 0) {
            quantity = parseFloat(quantity);

            // Calcular ingreso anual y mensual
            let annualIncome = quantity * 0.011 * 0.40; // Fórmula de ejemplo
            let monthlyIncome = annualIncome / 12;

            // Actualizar los resultados con formato de moneda
            $('#annually_fee').text(formatCurrency(annualIncome));
            $('#monthly_fee').text(formatCurrency(monthlyIncome));
        } else {
            // Si la cantidad es vacía o inválida, poner los resultados en 0.00
            $('#annually_fee').text(formatCurrency(0));
            $('#monthly_fee').text(formatCurrency(0));
        }
    }

    // Evento al hacer clic en el botón calcular
    $('.calculate_interest').on('click', function () {
        const quantity = $('#quantity').val().replace(/,/g, ''); // Extrae y limpia el valor del input
        updateResults(quantity); // Actualiza los resultados con la cantidad ingresada
    });

    // Formateo del input al perder el foco
    $('#quantity').on('blur', function () {
        if ($(this).val().trim() === '') {
            $(this).val('0.00');
            updateResults('0.00');
            initialValue = '0.00';
        } else {
            updateResults($(this).val().replace(/,/g, ''));
        }
    });

    // Formatear el input en tiempo real mientras el usuario escribe
    $('#quantity').on('input', function () {
        let value = $(this).val().replace(/[^0-9.]/g, ''); // Permitir solo números y un punto decimal

        // Asegurar que solo haya un punto decimal
        let parts = value.split('.');
        let integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","); // Agregar comas en la parte entera
        let decimalPart = parts[1] !== undefined ? '.' + parts[1] : ''; // Mantener la parte decimal si existe

        // Establecer el valor del input formateado
        $(this).val(integerPart + decimalPart);
    });

    // Inicializar los resultados al cargar la página
    updateResults(initialValue.replace(/,/g, ''));
}

// Función para formatear valores como moneda
function formatCurrency(number) {
    return '$' + number.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' MXN';
}
